// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_znU","cls2":"ImpactHubModal-cls2_2du ImpactHubModal-cls1_znU"};